import {ClassificationGroup} from "./classification-group";
import {Determinant} from "./determinant";
import {SelectOperatorType} from "./select-operator";
import {SelectSubjectType} from "./select-subject";
import {ClassificationField} from "./classification-field";

export class GroupingDeterminant extends Determinant {

  public subject: SelectSubjectType;
  public operator: SelectOperatorType;
  public classificationGroup: ClassificationGroup;
  public classificationTypeId: string;
  public classificationFields: ClassificationField[];
  public classificationField: ClassificationField; // parent catalog field

}
